import React from "react";
import styles from "./Divider.module.css";

const Divider = () => {
    return (
        <div className={styles.container}>
            <div className={styles.text}>Thông tin chi tiết</div>
            <div className={styles.line} />
        </div>

    )
}

export default Divider